import { createFileRoute } from '@tanstack/react-router';
import { FlowDetailPage } from '@/pages/admin/system-monitor/flow-detail-page';

export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/flow/$flowId'
)({
  component: FlowDetailPageWrapper,
});

function FlowDetailPageWrapper() {
  const { flowId } = Route.useParams();
  return <FlowDetailPage flowId={flowId} />;
}
